export function CrossChainExchangeIcon() {
  return (
    <svg
      width="335"
      height="196"
      viewBox="0 0 335 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_271_17)">
        <rect width="335" height="196" rx="14" fill="white" />
        <rect
          width="335"
          height="196"
          rx="14"
          fill="url(#paint0_radial_271_17)"
        />
        <path
          opacity="0.76"
          d="M4 153L104.717 59.7925H237.826L335 -37"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 116L104.717 22.7925H237.826L335 -74"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 190L104.717 96.7925H237.826L335 0"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 227L104.717 133.792H237.826L335 37"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 264L104.717 170.792H237.826L335 74"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 -34L104.717 59.6981H237.826L335 157"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 -71L104.717 22.6981H237.826L335 120"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 3L104.717 96.6981H237.826L335 194"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 40L104.717 133.698H237.826L335 231"
          stroke="white"
        />
        <path
          opacity="0.76"
          d="M4 77L104.717 170.698H237.826L335 268"
          stroke="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_271_17"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-347.803 291.958) rotate(-15.4288) scale(813.472 830.672)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#AC8FFF" />
        </radialGradient>
        <clipPath id="clip0_271_17">
          <rect width="335" height="196" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
